import { mapMutations, mapGetters, mapActions } from "vuex";
import { dynamicHead } from "../../mixins/dynamic-head";
import feedbackForm from "./components/feedback-form/index.vue";

export default {
    name: "support",
    data() {
        return {};
    },
    mixins: [dynamicHead],
    components: {
        feedbackForm,
    },
    computed: {
        ...mapGetters({
            contact: "contacts/contacts",
            supportList: "support/supportList",
            supportListLoading: "support/supportListLoading",
            seoData: "setting/seoData",
        }),
    },
    created() {
        this.getSeoData("support").then(() => {
            this.setPageItem(this.seoData);
        });
        if (!this.supportList) {
            this.fetchSupportList();
        }
    },
    methods: {
        ...mapActions({
            fetchSupportList: `support/GET_SUPPORT_LIST`,
            getSeoData: "setting/GET_SEO_DATA",
        }),
        ...mapMutations({}),
        getContactItem(item) {
            return this.contact.data[item];
        },
    },
    destroyed() {},
};
